(()=>{
'use strict';
const strings=window.merletStrings||{};
const params=new URLSearchParams(location.search);
const show=id=>{const d=document.getElementById(id+'-dialog');if(d&&!d.open)d.showModal();};

document.addEventListener('click',event=>{
  const open=event.target.closest('[data-open]');
  if(open){event.preventDefault();show(open.dataset.open);return;}
  const close=event.target.closest('[data-close]');
  if(close)close.closest('dialog')?.close();
  const info=event.target.closest('[data-info]');
  if(info){
    const key=info.dataset.info;
    document.querySelector('[data-info-title]').textContent=strings['info_'+key+'_title']||'';
    document.querySelector('[data-info-copy]').textContent=strings['info_'+key+'_copy']||'';
    show('info');
  }
  const select=event.target.closest('[data-select]');
  if(select){
    const input=document.querySelector('#enquiry-form [name="contact[product]"]');
    if(input){input.value=select.dataset.select;}
  }
  if(!event.target.closest('.product-menu'))document.querySelector('.product-menu')?.removeAttribute('open');
  if(event.target.closest('.product-dropdown a'))document.querySelector('.product-menu')?.removeAttribute('open');
});
document.querySelectorAll('dialog').forEach(d=>d.addEventListener('click',event=>{
  if(event.target!==d)return;
  const r=d.getBoundingClientRect();
  if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)d.close();
}));
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelector('.product-menu')?.removeAttribute('open');});

const toggle=document.querySelector('[data-menu]');
const mobileNav=document.querySelector('.mobile-nav');
toggle?.addEventListener('click',()=>{mobileNav.hidden=!mobileNav.hidden;toggle.setAttribute('aria-expanded',String(!mobileNav.hidden));});
mobileNav?.addEventListener('click',event=>{if(event.target.closest('a')){mobileNav.hidden=true;toggle?.setAttribute('aria-expanded','false');}});

const hero=document.querySelector('.hero');
const wallButton=document.querySelector('[data-wall-control]');
const syncWall=()=>{if(!wallButton)return;const paused=hero.classList.contains('is-paused');wallButton.setAttribute('aria-label',paused?'Play animation':'Pause animation');wallButton.innerHTML=paused?'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="m8 4 12 8-12 8Z"/></svg>':'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M8 5v14M16 5v14"/></svg>';};
wallButton?.addEventListener('click',()=>{hero.classList.toggle('is-paused');syncWall();});
if(hero&&matchMedia('(prefers-reduced-motion: reduce)').matches){hero.classList.add('is-paused');syncWall();}

const enquiry=document.getElementById('enquiry-form');
if(enquiry){
  const product=params.get('product');
  const productInput=enquiry.querySelector('[name="contact[product]"]');
  if(product&&productInput&&[...productInput.options].some(o=>o.value===product))productInput.value=product;
  if(enquiry.dataset.preview==='true'){
    enquiry.addEventListener('submit',event=>{
      event.preventDefault();
      if(!enquiry.reportValidity())return;
      const status=document.getElementById('enquiry-status');
      status.hidden=false;
      status.className='form-status is-success';
      status.innerHTML='<h3>Thanks — this is the local preview.</h3><p>On the live store this enquiry is sent straight to '+(enquiry.dataset.email||'the store inbox')+'. Nothing was sent from this preview.</p>';
      status.scrollIntoView({behavior:'smooth',block:'center'});
    });
  }
}
if(params.get('contact_posted')==='true'&&document.getElementById('enquiry-status')){
  document.getElementById('enquiry-status').hidden=false;
}
})();
